import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import DesktopLayout from './desktop';
import MobileLayout from './mobile';
import useIndex from './useIndex';

const App = () => {
  const viewModel = useIndex();

  return (
    <BrowserRouter basename='/'>
      {viewModel.isMobile ? (
        <MobileLayout viewModel={viewModel} />
      ) : (
        <DesktopLayout viewModel={viewModel} />
      )}
    </BrowserRouter>
  );
};

export default App;